<template>
    <div class="DshButtons">
        <Button
            v-for="(operationItem, index) in list"
            :key="operationItem.type"
            :style="operationItem.style"
            :class="[
                !operationItem.custom && !operationItem.icon ? 'DshButtons-item' : undefined,
                index ? 'dsh-margin-left5' : undefined,
                itemClass,
                operationItem.class
            ]"
            :type="operationItem.btnType"
            :ghost="operationItem.ghost"
            :size="operationItem.size"
            :shape="operationItem.shape"
            :long="operationItem.long"
            :disabled="operationItem.disabled"
            :icon="operationItem.custom ? undefined : operationItem.icon"
            :custom-icon="operationItem.custom ? `bico-font ${operationItem.custom}` : undefined"
            @click="emit(operationItem)"
        >
            <span
                v-if="operationItem.name"
                class="DshButtons-item-name"
            >{{ operationItem.name }}</span>
        </Button>
    </div>
</template>

<script>
    export default {
        name: "DshButtons",
        props: {
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            itemClass: String
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {
            emit (operationItem) {
                this.$emit("click", operationItem);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshButtons.vue